module.exports = __webpack_public_path__ + "static/media/photo_image.f0fac2b7.jpeg";